// @import
import { ensureHTMLElement } from "@src/js/lib/ensure";
import { addPrevNextBtnsClickHandlers } from "@src/js/lib/slider";
import Alpine from "alpinejs";
import EmblaCarousel from "embla-carousel";
import ClassNames from "embla-carousel-class-names";

Alpine.directive("films-highlights", (element, {}, { cleanup }) => {
  const OPTIONS = { align: "start", duration: 20, inViewThreshold: 0.9 } as const;

  const dom = {
    viewportNode: element.querySelector<HTMLElement>(".c-films-highlights__viewport"),
    nextBtnNode: element.querySelector<HTMLButtonElement>(".c-films-highlights__next-btn"),
    prevBtnNode: element.querySelector<HTMLButtonElement>(".c-films-highlights__prev-btn"),
  };

  if (!dom.viewportNode || !dom.nextBtnNode || !dom.prevBtnNode) {
    return;
  }

  let isScrolling = false;
  let lastProgress = 0;

  function onScroll(e) {
    if (!isScrolling) {
      dom.viewportNode?.classList.add("is-scrolling");
      // Delelte any previous clone just in case and create a new one
      document.body.querySelectorAll(".c-card-film-details--open").forEach((el) => el.remove());
      isScrolling = true;
    }
    const progress = e.scrollProgress();
    if (Math.abs(progress - lastProgress) < 0.0003) {
      if (isScrolling) {
        dom.viewportNode?.classList.remove("is-scrolling");
        isScrolling = false;
      }
    }
    lastProgress = progress;
  }
  const emblaApi = EmblaCarousel(ensureHTMLElement(dom.viewportNode), OPTIONS, [ClassNames()]);

  emblaApi.on("scroll", onScroll);

  const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(emblaApi, {
    nextBtn: dom.nextBtnNode,
    prevBtn: dom.prevBtnNode,
  });

  emblaApi.on("destroy", removePrevNextBtnsClickHandlers);

  cleanup(() => {
    emblaApi.off("scroll", onScroll);
    emblaApi.destroy();
  });
});
